class CountdownTimer {
  constructor(element) {
    this.element = element;
    this.endDate = new Date(element.dataset.endDate).getTime();
    this.showDays = element.dataset.showDays === 'true';
    this.showHours = element.dataset.showHours === 'true';
    this.showMinutes = element.dataset.showMinutes === 'true';
    this.showSeconds = element.dataset.showSeconds === 'true';
    
    this.daysElement = element.querySelector('[data-days]');
    this.hoursElement = element.querySelector('[data-hours]');
    this.minutesElement = element.querySelector('[data-minutes]');
    this.secondsElement = element.querySelector('[data-seconds]');
    
    this.interval = null;
    
    if (isNaN(this.endDate)) {
      console.error('Invalid end date format');
      return;
    }
    
    this.start();
  }
  
  start() {
    this.update();
    this.interval = setInterval(() => this.update(), 1000);
  }
  
  update() {
    const now = new Date().getTime();
    const distance = this.endDate - now;
    
    if (distance < 0) {
      this.stop();
      this.element.classList.add('countdown-expired');
      return;
    }
    
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
    if (this.showDays && this.daysElement) {
      this.daysElement.textContent = this.padZero(days);
    }
    
    if (this.showHours && this.hoursElement) {
      this.hoursElement.textContent = this.padZero(hours);
    }
    
    if (this.showMinutes && this.minutesElement) {
      this.minutesElement.textContent = this.padZero(minutes);
    }
    
    if (this.showSeconds && this.secondsElement) {
      this.secondsElement.textContent = this.padZero(seconds);
    }
  }
  
  padZero(num) {
    return num.toString().padStart(2, '0');
  }
  
  stop() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }
}

// Initialize all countdown timers on the page
function initCountdownTimers() {
  const timers = document.querySelectorAll('[data-countdown-timer]');
  timers.forEach(timer => {
    new CountdownTimer(timer);
  });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCountdownTimers);
} else {
  initCountdownTimers();
}

// Re-initialize on section render (for theme editor)
if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initCountdownTimers);
}
